export default __webpack_public_path__ + "static/media/ABChanelCorpo-Regular.13e9a041.ttf";